var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFfr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 18,
    height: 18,
    rx: 5,
    fill: "#000000",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3,8.5862064L5.4827588,8.5862064L7.034483,7.034483L8.275862199999999,8.5862064Q8.896551599999999,7.6551723,8.5862069,7.034483Q8.275862199999999,6.4137930999999995,7.9655175,6.1034483999999996L8.5862069,5.4827588L11.6896553,8.5862064L14.172414,8.5862064L8.5862069,3L3,8.5862064Z",
    fill: "#40EEF0",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,-1,28.34482765197754,29.58642578125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.17241382598877,20.379419290625002L16.65517262598877,20.379419290625002L18.20689682598877,18.827695890625L19.44827602598877,20.379419290625002Q20.068965425988768,19.448385190625,19.75862072598877,18.827695890625Q19.44827602598877,18.207005990625,19.13793132598877,17.896661290625L19.75862072598877,17.275971690625L22.862069125988768,20.379419290625002L25.34482782598877,20.379419290625002L19.75862072598877,14.793212890625L14.17241382598877,20.379419290625002Z",
    fill: "#40EEF0",
    fillOpacity: 1
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFfr);
export default __webpack_public_path__ + "static/media/FFR.d0e862272123b83bf97ec6a0ece12384.svg";
export { ForwardRef as ReactComponent };